import { primaryColor } from "colors-config";

export const ALIGNER_COLOR_CONFIGURATION = [
  "#85CDCA", // Light teal
  "#FF6F61", // Bright warm red
  "#FFC75F", // Warm golden yellow
  "#6B5B95", // Muted purple
  "#64B5F6", // Sky blue
  "#88B04B", // Soft green
  "#FF847C", // Coral pink
  "#45B8AC", // Cool teal
  "#F49AC2", // Light pink
  "#F4A460", // Sandy brown
  "#FF7043", // Vivid orange
  "#7FCDCD", // Cyan
  "#FF4081", // Bright pink
  "#92A8D1", // Cool blue-gray
  "#6A0572", // Deep purple
  "#9575CD", // Lavender
  "#FFD54F", // Warm yellow
  "#41B3A3", // Sea green
  "#daa520", // Goldenrod
  "#E15D44", // Reddish-orange
  "#F7CAC9", // Pale pink
  "#BC243C", // Dark magenta
  "#F9F871", // Lemon yellow
  "#C3447A", // Rose pink
  "#A7226E", // Deep magenta
  "#FF9671", // Peach
  "#E8A87C", // Soft tan
  "#9B2335", // Crimson
  "#00FFF0", // Soft aqua
  "#FFB347", // Tangerine
  "#A8E6CF", // Mint
  "#FFCA28", // Bright yellow
  "#FF8C94", // Soft red
  "#39A275", // Forest green
  "#C38D9E", // Light mauve
  "#6C5B7B", // Dusty purple
  "#A9A9A9", // Dark gray
  "#DB7093", // Pale violet red
  "#D4A5A5", // Light pink-beige
  "#B6B5A3", // Taupe
  "#FFAB91", // Peach-orange
  "#DC4C46", // Bright red
  "#C1C8E4", // Light periwinkle
  "#9191E9", // Soft blue
  "#FFAE42", // Bright yellow-orange
  "#D5A6BD", // Soft mauve
  "#D6C5C5", // Pale rose
  "#A0E7E5", // Light cyan
  "#FFF59D", // Pale yellow
  "#77DD77", // Light green
  "#2A363B", // Dark gray-blue
  "#F6D55C", // Warm yellow
  "#C06C84", // Soft rose
  "#355C7D", // Muted navy
  "#E27D60", // Coral
  "#99B898", // Sage green
  "#FFF176", // Bright lemon yellow
  "#B68973", // Soft brown
  "#F39237", // Orange
  "#636363", // Charcoal gray
  "#7986CB", // Dusty lavender
  "#B2DFDB", // Pale turquoise
  "#DCE775", // Light lime
  "#FDFD96", // Soft yellow
  "#F1F8E9", // Pale green
  "#FFF8E1", // Cream
  "#FFE082", // Soft gold
  "#FFEB3B", // Bright yellow
  "#FFCDD2", // Pale red
  "#D7CCC8", // Soft brown
  "#D65076", // Soft red-violet
  "#FFECB3", // Pale gold
  "#D9BF77", // Tan
  "#C2E0C6", // Soft green
  "#F7DB4F", // Golden yellow
  "#F5F5DC", // Pale beige
  "#FDB0C0", // Soft pink
  "#E2B227", // Gold
  "#FEBE7E", // Soft orange
  "#ED553B", // Bright coral
  "#B2EBF2", // Light cyan
  "#C8E6C9", // Light mint
  "#FFE0B2", // Soft peach
  "#EE4B2B", // Bright red
  "#6488EA", // Soft blue
  "#FFDF00", // Golden yellow
  "#F3E5F5", // Pale lavender
  "#E8EAF6", // Pale blue
  "#EFC050", // Gold
  "#E1F5FE", // Light blue
  "#DCEDC8", // Pale green
  "#E3F2FD", // Soft blue
  "#FBE9E7", // Pale coral
  "#C6FFDD", // Soft green
  "#FFB6C1",
  "#4682B4",
  "#32CD32",
  "#DAA560",
  "#8A2BE2",
  "#FF4500",
];

export function getAlignerBackground(aligner, upperAligner) {
  let bg = "#0000";
  if (aligner.value) {
    bg = primaryColor;
  }
  return bg;
}

export function getAlignerNumberBackground(aligner) {
  let bg = "#fff";
  if (aligner) {
    bg = primaryColor;
  }
  return bg;
}

export const iprUpperIndexes = {
  0: "18-17",
  1: "17-16",
  2: "16-15",
  3: "15-14",
  4: "14-13",
  5: "13-12",
  6: "12-11",
  7: "11-21",
  8: "21-22",
  9: "22-23",
  10: "23-24",
  11: "24-25",
  12: "25-26",
  13: "26-27",
  14: "27-28",
};

const iprUpperIndexesUniversal ={
  0: "1-2",
  1: "2-3",
  2: "3-4",
  3: "4-5",
  4: "5-6",
  5: "6-7",
  6: "7-8",
  7: "8-9",
  8: "9-10",
  9: "10-11",
  10: "11-12",
  11: "12-13",
  12: "13-14",
  13: "14-15",
  14: "15-16",
}

const iprUpperIndexesPalmer ={
  0: "UR8-UR7",
  1: "UR7-UR6",
  2: "UR6-UR5",
  3: "UR5-UR4",
  4: "UR4-UR3",
  5: "UR3-UR2",
  6: "UR2-UR1",
  7: "UR1-UL1",
  8: "UL1-UL2",
  9: "UL2-UL3",
  10: "UL3-UL4",
  11: "UL4-UL5",
  12: "UL5-UL6",
  13: "UL6-UL7",
  14: "UL7-UL8",
}


const iprLowerIndexesPalmer ={
  0: "LR8-LR7",
  1: "LR7-LR6",
  2: "LR6-LR5",
  3: "LR5-LR4",
  4: "LR4-LR3",
  5: "LR3-LR2",
  6: "LR2-LR1",
  7: "LR1-LL1",
  8: "LL1-LL2",
  9: "LL2-LL3",
  10: "LL3-LL4",
  11: "LL4-LL5",
  12: "LL5-LL6",
  13: "LL6-LL7",
  14: "LL7-LL8",
}

const iprLowerIndexesUniversal ={
  0: "17-18",
  1: "18-17",
  2: "36-35",
  3: "35-34",
  4: "34-33",
  5: "33-32",
  6: "32-31",
  7: "31-30",
  8: "30-29",
  9: "29-28",
  10: "28-27",
  11: "27-26",
  12: "26-25",
  13: "25-24",
  14: "24-23",
}

export const iprLowerIndexes = {
  0: "48-47",
  1: "47-46",
  2: "46-45",
  3: "45-44",
  4: "44-43",
  5: "43-42",
  6: "42-41",
  7: "41-31",
  8: "31-32",
  9: "32-33",
  10: "33-34",
  11: "34-35",
  12: "35-36",
  13: "36-37",
  14: "37-38",
};


export const getIprUpperIndex = (index, chartType) => {
  switch (chartType) {
    case "fdi":
      return iprUpperIndexes[index] || "Not found";
    case "universal":
      return iprUpperIndexesUniversal[index] || "Not found";
    case "palmer":
      return iprUpperIndexesPalmer[index] || "Not found";
    default:
      return "Invalid chart type";
  }
};

export const getIprLowerIndex = (index, chartType) => {
  switch (chartType) {
    case "fdi":
      return iprLowerIndexes[index] || "Not found";
    case "universal":
      return iprLowerIndexesUniversal[index] || "Not found";
    case "palmer":
      return iprLowerIndexesPalmer[index] || "Not found";
    default:
      return "Invalid chart type";
  }
};
